import styled from 'styled-components';

import { Button, ButtonProps } from '@components/button';
import { IconDropdown } from '@components/icons/dropdown';
import { Menu } from '@components/menu';
import { pxToRem } from '@utils/converters';

export type ComboMenuProps = {
  children: React.ReactNode;
  buttonProps: ButtonProps;
};

export const ComboMenu = ({ children, buttonProps }: ComboMenuProps) => {
  const hasMenu = Boolean(children);
  return (
    <ComboContainer data-has-menu={hasMenu}>
      <Button {...buttonProps} />
      {hasMenu && (
        <Menu
          width={pxToRem(312)}
          buttonProps={{
            variant: buttonProps.variant,
            size: buttonProps.size,
            iconLeft: <IconDropdown />,
          }}
        >
          {children}
        </Menu>
      )}
    </ComboContainer>
  );
};

const ComboContainer = styled.div({
  display: 'flex',
  '&[data-has-menu="true"]': {
    '>button:first-child': {
      borderTopRightRadius: pxToRem(0),
      borderBottomRightRadius: pxToRem(0),
    },
    '.menu-button': {
      marginLeft: pxToRem(2),
      borderTopLeftRadius: pxToRem(0),
      borderBottomLeftRadius: pxToRem(0),
      width: pxToRem(32),
    },
  },
});
